<template>
  <div>
    <div class="dashboard-kpi p-2">
      <div class="pointer" style="position:absolute;right:3%; top: 2%;" @click="downloadReport()">
        <i class="fa-solid fa-file-arrow-down" style="color:red;  font-size: large;"></i>
      </div>
      <div class="text-bold text-center">
        Supplier Satisfaction Index - Total PO
      </div>
      <div class="bg-chart">
        <div class="doughnat-container">
          <!-- <div class="text-bold text-center">{{ labels }}</div> -->
          <pie-chart :chartData="chart[`chartData`]" :options="chart[`chartOptions`]"
            :styles="{ height: '75%', listStyleType: 'none' }" v-if="ssiChart" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as XLSX from 'sheetjs-style'
export default {
  components: {
    PieChart: () => import('@/components/chart/dashboard/pie-chart.vue'),
  },
  data() {
    return {
      labels: [''],
      chart: {
        chartData: {
          labels: [
            'Sangat Memuaskan',
            'Memuaskan',
            'Cukup Memuaskan',
            'Tidak Memuaskan',
            'Sangat Buruk',
          ],
          datasets: [
            {
              backgroundColor: ['#ED1D24', '#F33', '#EE6066', '#F60', '#F96'],
              data: [90, 50, 50, 50, 60],
            },
          ],
        },

        chartOptions: {
          responsive: true,
          display: true,
          fullWidth: false,
          maintainAspectRatio: false,
          legend: {
            position: 'right',
            labels: {
              generateLabels(chart) {
                const data = chart.data
                if (data.labels.length && data.datasets.length) {
                  return data.labels.map((label, i) => {
                    const dataset = data.datasets[0]
                    const percentage = (
                      (dataset.data[i] / dataset.data.reduce((a, b) => a + b)) *
                      100
                    ).toFixed(2)
                    return {
                      text: `${dataset.data[i]} (${isNaN(percentage) ? 0 : percentage
                        }%) - ${label}`,
                      fillStyle: dataset.backgroundColor[i],
                      hidden:
                        isNaN(dataset.data[i]) ||
                        chart.getDatasetMeta(0).data[i].hidden,
                      lineCap: 'round',
                    }
                  })
                }
                return []
              },
            },
          },
        },
      },
    }
  },
  computed: {
    ssiChart() {
      const data = this.$store.state.kpiStore.ssiChartTotalPo
      this.convertData(data)

      return data
    },
    totalPoDetail() {
      const data = this.$store.state.kpiStore.ssiChartTotalPoAmount

      return data
    }
  },
  methods: {
    convertData(data) {
      const newData = Object.values(data)

      if (newData.length > 0) {
        let status = {
          sangat_puas: 0,
          puas: 0,
          cukup_puas: 0,
          tidak_puas: 0,
          sangat_buruk: 0,
        }

        for (let convert of newData) {
          status[convert.csi_desc] = convert.jumlah
        }

        const chartData = {
          labels: [
            'Sangat Memuaskan',
            'Memuaskan',
            'Cukup Memuaskan',
            'Tidak Memuaskan',
            'Sangat Buruk',
          ],
          datasets: [
            {
              backgroundColor: ['#ED1D24', '#F33', '#EE6066', '#F60', '#F96'],
              data: [
                status.sangat_puas,
                status.puas,
                status.cukup_puas,
                status.tidak_puas,
                status.sangat_buruk,
              ],
            },
          ],
        }

        this.chart = {
          ...this.chart,
          chartData,
        }
      } else {
        const chartData = {
          labels: [
            'Sangat Memuaskan',
            'Memuaskan',
            'Cukup Memuaskan',
            'Tidak Memuaskan',
            'Sangat Buruk',
          ],
          datasets: [
            {
              backgroundColor: ['#ED1D24', '#F33', '#EE6066', '#F60', '#F96'],
              data: [0, 0, 0, 0, 0],
            },
          ],
        }

        this.chart = {
          ...this.chart,
          chartData,
        }
      }
    },
    downloadReport() {
      const exportTitle = 'SSI - Total PO'
      let newData = this.totalPoDetail.map((item, index) => {
        let newDataItem = {
          no: index + 1,
          po_number: item.po_number,
          PCR_GROUP: item.PCR_GROUP,
          VENDOR_NAME: item.VENDOR_NAME,
          CSI_SCORE: item.CSI_SCORE,
          csi_desc: item.csi_desc,
          TOTAL_VALUE_IDR: this.curencyDelimiter(item.TOTAL_VALUE_IDR),
        }

        return newDataItem
      })

      // newData.unshift({})

      let wb = XLSX.utils.book_new()
      let sheet = [exportTitle]
      sheet.forEach(list => {
        let dataToExport = XLSX.utils.json_to_sheet(newData)
        const title = [
          ['NO', 'PO NUMBER', 'PCR GROUP', 'NAMA VENDOR', 'NILAI', 'TINGKAT KEPUSAN', 'NILAI PO'],
        ]
        XLSX.utils.book_append_sheet(wb, dataToExport, list)
        XLSX.utils.sheet_add_aoa(dataToExport, title, {
          origin: 'A1',
        })
      })
      XLSX.writeFile(wb, `${exportTitle}.xlsx`)
    },
  },
}
</script>

<style scoped>
.doughnat-container {
  display: flex;
  justify-content: center;
  align-items: center;

  margin: 60px auto;
  width: 100%;
  max-width: 40vw;
  height: 100%;
  max-height: 50vh;
  background-color: rgb(237, 231, 231);
  border-radius: 8px;
  box-shadow: 0 1px 5px 3px gray;
  cursor: pointer;
}
</style>
